export default {
  GETUSER (state, token) { // 设置登录TOken
    state.TOKEN = token
  },
  GETLOGINUSER (state, obj) {
    state.LOGINUSER = obj
    state.TOKEN = obj ? obj.sid : '';
  },
  GETUSERLIST (state,data) {
    state.userList = data
  },
  SET_TOTAL_NUM(state,data){
    state.totalNum = data;
  },
  SET_USER_LIST(state,data){
    state.userList = data;
  },
  //设置支付密码状态
  SET_PASSWORD_FLAG(state,data){
    state.passwordFlag = data;
  },
  SET_TOTAL_CORN(state,data){
    state.totalCorn = data;
  }
}
